export default __webpack_public_path__ + "static/media/summary.9712cab6.svg";